export default "__VITE_ASSET__DggY5VRF__"